import { render, staticRenderFns } from "./ParcelRoot.vue?vue&type=template&id=40efecf6&"
import script from "./ParcelRoot.vue?vue&type=script&lang=ts&"
export * from "./ParcelRoot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports